import { request } from "@/api";
import cookies from 'js-cookie';
import { getStringYmdtWithoutSeparator } from '@/utils/dateUtils';

const ENDPOINT_ACHIEVEGOAL_TARGETDATA = 'AchieveGoal/TargetData';
const ENDPOINT_ACHIEVEGOAL_RECOMMENDGOALINBODYDATA = 'AchieveGoal/RecommendGoalInBodyData';
const ENDPOINT_ACHIEVEGOAL_SAVEGOAL = 'AchieveGoal/SaveGoal';
const ENDPOINT_ACHIEVEGOAL_GOALINBODYDATA = 'AchieveGoal/GoalInBodyData';

export default {
    namespaced: true,
    state: {
        bigDataGuideTargetData: null,
        recGoalInBodyData: null,
        setupInfo: {
            datetime: '',
            goalCode: '',
            week: '',
            startDate: null,
            startInBodyData: null,
            goalInBodyData: null
        },
        achieveGoalKey: '',
    },
    actions: {
        async getTargetData ({ state }, payload) {
            const resp = await request(ENDPOINT_ACHIEVEGOAL_TARGETDATA, "post", {
                datetimes: getStringYmdtWithoutSeparator(payload.datetimes),
                uId: cookies.get('UID'),
                appType: cookies.get('AppType'),
                appVersion: cookies.get('AppVersion'),
                languageCode: cookies.get('LanguageCode'),
                countryCode: cookies.get('CountryCode'),
                utcInterval: cookies.get('UTCInterval'),
                whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode'),
                challengeId: payload.challengeId ?? null
            });
            if (resp.data !== undefined && resp.data !== null) {
                console.log(resp.data);
                state.bigDataGuideTargetData = resp.data
            }
        },
        async getRecommendGoalInBodyData ({ state }, payload) {
            const resp = await request(ENDPOINT_ACHIEVEGOAL_RECOMMENDGOALINBODYDATA, "post", {
                goalCode: payload.goalCode,
                datetimes: getStringYmdtWithoutSeparator(state.setupInfo.datetime),
                uId: cookies.get('UID'),
                appType: cookies.get('AppType'),
                appVersion: cookies.get('AppVersion'),
                languageCode: cookies.get('LanguageCode'),
                countryCode: cookies.get('CountryCode'),
                utcInterval: cookies.get('UTCInterval'),
                whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
            });
            if (resp.data !== undefined && resp.data !== null) {
                console.log(resp.data);
                state.recGoalInBodyData = resp.data
            }
        },
        async setGoalData ({ state, dispatch }, payload) {
            const resp = await request(ENDPOINT_ACHIEVEGOAL_SAVEGOAL, "post", {
                datetimes: getStringYmdtWithoutSeparator(state.setupInfo.datetime),
                goalCode: payload.goalCode ?? state.setupInfo.goalCode,
                weekNum: state.setupInfo.week,
                challengeId: payload.challengeId ?? null,
                fixDayNum: payload.fixDayNum ?? null,
                startDatetime: payload.startDate,
                uId: cookies.get('UID'),
                appType: cookies.get('AppType'),
                appVersion: cookies.get('AppVersion'),
                languageCode: cookies.get('LanguageCode'),
                countryCode: cookies.get('CountryCode'),
                utcInterval: cookies.get('UTCInterval'),
                whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
            });
            if (resp.data !== undefined && resp.data !== null) {
                console.log(resp.data);
                state.achieveGoalKey = resp.data.achieveGoalKey;

                dispatch('getGoalInBodyData');
            }
        },
        async getGoalInBodyData ({ state }) {
                const resp = await request(ENDPOINT_ACHIEVEGOAL_GOALINBODYDATA, "post", {
                datetimes: getStringYmdtWithoutSeparator(state.setupInfo.datetime),
                achieveGoalKey: state.achieveGoalKey,
                uId: cookies.get('UID'),
                appType: cookies.get('AppType'),
                appVersion: cookies.get('AppVersion'),
                languageCode: cookies.get('LanguageCode'),
                countryCode: cookies.get('CountryCode'),
                utcInterval: cookies.get('UTCInterval'),
                whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
            });
            if (resp.data !== undefined && resp.data !== null) {
                console.log(resp.data);
                
                state.setupInfo.goalInBodyData = {
                    wt: resp.data.goalData.wtGoal,
                    pWt: resp.data.goalData.pWtGoal,
                    smm: resp.data.goalData.smmGoal,
                    pSmm: resp.data.goalData.pSmmGoal,
                    bfm: resp.data.goalData.bfmGoal,
                    pFatNew: resp.data.goalData.pFatNewGoal,
                }
            }
        }
    },
    mutations: {
        SET_START_INBODY_DATA (state, payload) {
            state.setupInfo.datetime = payload.datetime;
            state.setupInfo.startInBodyData = payload.inbodyData;
        },
        SET_GOAL_INBODY_DATA (state, payload) {
            state.setupInfo.goalCode = payload.goalCode;
            state.setupInfo.goalInBodyData = payload.inbodyData;
        },
        SET_GOAL_PERIOD (state, payload) {
            state.setupInfo.week = payload.goalWeek;
            state.setupInfo.startDate = payload.startDate;
        }
    }
}